// extracted by mini-css-extract-plugin
module.exports = {"container":"PricesFooter_container__jxSTE","button":"PricesFooter_button__o374a"};